import React, { useState } from 'react';
import { Lock, ChevronDown, ChevronUp, Globe } from 'lucide-react';
import { useLang } from '../../i18n/LanguageContext';

const OfficialBanner = () => {
  const [open, setOpen] = useState(false);
  const { lang, toggle, t } = useLang();

  return (
    <div className="bg-[#f0f0f0] border-b border-gray-300 text-[#1b1b1b] text-[13px]">
      <div className="max-w-7xl mx-auto px-4 py-2">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center gap-3">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Coat_of_arms_of_Indonesia_Garuda_Pancasila.svg/60px-Coat_of_arms_of_Indonesia_Garuda_Pancasila.svg.png"
              alt="Lambang"
              className="w-4 h-4"
            />
            <span>{t('officialSiteBanner')}</span>
          </div>
          <div className="flex items-center gap-4">
            <button
              onClick={toggle}
              className="flex items-center gap-1.5 px-2 py-1 border border-gray-400 hover:bg-[#0a1929] hover:text-white hover:border-[#0a1929] rounded text-[12px] font-semibold transition"
              title="Ubah bahasa / Switch language"
            >
              <Globe size={13} />
              <span className={lang === 'id' ? 'text-[#0a1929]' : 'opacity-60'}>ID</span>
              <span className="opacity-40">|</span>
              <span className={lang === 'en' ? 'text-[#0a1929]' : 'opacity-60'}>EN</span>
            </button>
            <button onClick={() => setOpen(!open)} className="flex items-center gap-1 text-[#005ea2] hover:underline">
              {t('howToRecognize')}
              {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
            </button>
          </div>
        </div>
        {open && (
          <div className="mt-3 grid md:grid-cols-2 gap-4 text-[13px] pb-2">
            <div className="flex gap-3">
              <div className="w-6 h-6 flex-shrink-0 rounded-full bg-[#005ea2] text-white grid place-items-center text-[10px] font-bold">.id</div>
              <div>
                <strong className="block">{lang === 'id' ? 'Situs resmi menggunakan .id / .go.id' : 'Official sites use .id / .go.id'}</strong>
                {lang === 'id' ? 'Domain .id atau .go.id adalah milik organisasi resmi di Indonesia.' : 'The .id or .go.id domain belongs to an official organization in Indonesia.'}
              </div>
            </div>
            <div className="flex gap-3">
              <div className="w-6 h-6 flex-shrink-0 rounded-full bg-[#005ea2] text-white grid place-items-center"><Lock size={12} /></div>
              <div>
                <strong className="block">{lang === 'id' ? 'Situs aman menggunakan HTTPS' : 'Secure sites use HTTPS'}</strong>
                {lang === 'id' ? 'Gembok atau https:// berarti Anda terhubung dengan aman ke situs resmi.' : 'A lock or https:// means you are safely connected to the official site.'}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OfficialBanner;
